import 'react-polymer' // Must be imported before React
import React from 'react';
import StaticPage from '../StaticPage';
import localize from '../../components/localize';
import PageHeader from '../../components/PageHeader';
import './Steps.css';

const sections = ['before', 'your_computer', 'your_network', 'your_isp', 'after'];
const tools = ['chat', 'hextech', 'status'];

export default localize('pages.steps')(({ i18n }) => {
	let steps = sections.map((section) => (<StepSection i18nPath={i18n.path('sections.' + section)} key={section} section={section} />));

	return (<StaticPage i18nPath={i18n.path()}>
						<div className="centered-content">
              {steps}

              <div id="tools">
                <PageHeader className="subheader" header={i18n.t('other_tools.header')} />
                <ToolBar i18nPath={i18n.path('other_tools')} />
              </div>
            </div>
					</StaticPage>
				 );
});

const StepSection = localize()(({ i18n, section }) => {
    return (
      <section className="step">
        <h2>{i18n.t('header')}</h2>
        <span className={`icon ${section}`}></span>
        <div dangerouslySetInnerHTML={{ __html: i18n.t('body')}} className="step-content" />
      </section>
    );
});

const ToolBar = localize()(({ i18n }) => {
	let buttons = tools.map((tool) => (<Tool i18nPath={i18n.path(tool)} key={tool} image={tool} />));

	return (
		<q-grid>
			{buttons}
		</q-grid>
	);
});

const Tool = localize()(({ i18n, image }) => (
    <q-col lg-size="4" md-size="6">
			<a href={i18n.t('link')}>
				<q-overlay-card horizontal-align="center" vertical-align="center" image={image}>
					<q-overlay-card-model-simple-5>
						<h2>{i18n.t('title')}</h2>
						<q-subtext>{i18n.t('subtitle')}</q-subtext>
						<q-icon name="long-arrow-right"></q-icon>
					</q-overlay-card-model-simple-5>
				</q-overlay-card>
			</a>
		</q-col>));



// WEBPACK FOOTER //
// ./src/pages/Steps/index.js